import Vue from 'vue'
import Vuex from 'vuex'
import fabrics from './modules/fabrics'
import order from './modules/order'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  // strict: debug,
  modules: {
    fabrics,
    order,
  }
})

export default store
